import {
  REMEMBER_SIGN_IN_EMAIL_ENABLED_KEY,
  REMEMBER_SIGN_IN_EMAIL_KEY,
} from '@/composables/auth/constants'

const ENABLED_VALUE = 'true'

const canUseLocalStorage = () => typeof window !== 'undefined'

const normalizeEmailAddress = (emailAddress?: string | null) => {
  const trimmed = emailAddress?.trim()
  return trimmed ? trimmed.toLowerCase() : undefined
}

const readItem = (key: string) => {
  if (!canUseLocalStorage()) {
    return null
  }

  try {
    return localStorage.getItem(key)
  } catch (error) {
    console.warn(`[Auth] Failed to read ${key}:`, error)
    return null
  }
}

const writeItem = (key: string, value: string) => {
  if (!canUseLocalStorage()) {
    return
  }

  try {
    localStorage.setItem(key, value)
  } catch (error) {
    console.warn(`[Auth] Failed to write ${key}:`, error)
  }
}

const removeItem = (key: string) => {
  if (!canUseLocalStorage()) {
    return
  }

  try {
    localStorage.removeItem(key)
  } catch (error) {
    console.warn(`[Auth] Failed to remove ${key}:`, error)
  }
}

export const isRememberSignInEmailEnabled = () => readItem(REMEMBER_SIGN_IN_EMAIL_ENABLED_KEY) === ENABLED_VALUE

export const getRememberedSignInEmail = () => normalizeEmailAddress(readItem(REMEMBER_SIGN_IN_EMAIL_KEY))

export const clearRememberedSignInEmail = () => {
  removeItem(REMEMBER_SIGN_IN_EMAIL_KEY)
}

export const setRememberSignInEmailEnabled = (enabled: boolean) => {
  if (enabled) {
    writeItem(REMEMBER_SIGN_IN_EMAIL_ENABLED_KEY, ENABLED_VALUE)
    return
  }

  removeItem(REMEMBER_SIGN_IN_EMAIL_ENABLED_KEY)
  clearRememberedSignInEmail()
}

export const persistRememberedSignInEmailAfterSignIn = (emailAddress?: string) => {
  if (!isRememberSignInEmailEnabled()) {
    clearRememberedSignInEmail()
    return
  }

  const normalized = normalizeEmailAddress(emailAddress)
  if (normalized) {
    writeItem(REMEMBER_SIGN_IN_EMAIL_KEY, normalized)
  }
}
